<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import moment from 'moment'
    
    export default {
        page: {
            title: "TV Show Details",
            meta: [
                {
                name: "description",
                content: appConfig.description,
                },
            ],
        },
        components: { Layout, PageHeader },
        data() {
            const today_str = new Date().toJSON().slice(0, 10);
            return {
                title: "TV Show Details",
                items: [
                {
                    text: "TV Show",
                    href: "/tvshows",
                },                
                
                {
                    text: "Details",
                    active: true,
                },                     
                ],

                tv_show: {},
                tv_names: [],

                errors: {},
                token: '',
                loading: false,

                today: today_str,
                renew: {
                    validity: '',
                    remarks: '',
                },
                renew_errors: {},
                renew_loading: false,
                renew_logs: [],
                logs_loading: false,

            };
        },
        mounted() {
        
        },

        created() {
            this.fetchTvShowDetail();
        },

        methods: {

            getToken() {
                if (localStorage.getItem('medicino_admin')) {
                var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
                if(medicino_admin.token) {
                    this.token = medicino_admin.token;
                } else {
                    this.$swal("", "Failed to fetch token, please login again", "error");
                    this.$router.push({ name: "login" });
                }
                
                } else {
                this.$swal("", "Session expired, please login again", "error");
                this.$router.push({ name: "login" });
                }
            }, 

            fetchTvShowDetail() {
                let url = "api/admin/tvShowDetail?id=" + this.$route.params.id;         
                this.getToken();
                this.loading = true;
                this.logs_loading = true;
                this.$axios
                .get(url, { headers: { Authorization: "Bearer " + this.token } })
                .then((res) => {
                var responseData = res.data.data;
                this.tv_show = responseData.tv_shows || {};  
                this.tv_names = this.tv_show.tv_names || [];
                this.renew_logs = responseData.renew_logs
                    || this.tv_show.renew_logs
                    || [];
                        
                })
                .catch((error) => {
                    if (error.response) {
                        if (error.response.data.message) {
                            if(typeof error.response.data.message === 'object') {
                            console.log(error.response.status);
                            } else {
                            this.$swal("", error.response.data.message, "error");
                            }                        
                            
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    } else {
                        this.$swal("", "Something went wrong", "error");
                    }
                })
                .finally(() => {
                    this.loading = false;
                    this.logs_loading = false;
                });
            },

            showModal(modal) {
                this.$refs[modal].show();
            },

            hideModal(modal) {
                this.$refs[modal].hide();
            },

            openRenewModal() {
                this.renew_errors = {};
                this.renew.validity = '';
                this.renew.remarks = '';
                this.showModal('renew-modal');
            },

            clearRenewForm() {
                this.renew.validity = '';
                this.renew.remarks = '';
                this.renew_errors = {};
                this.renew_loading = false;
            },

            renewTVShow() {
                this.getToken();
                this.renew_errors = {};

                const config = {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + this.token,
                    },
                };

                const payload = {
                    tv_show_id: Number(this.$route.params.id),
                    validity: this.renew.validity,
                };

                if (this.renew.remarks && this.renew.remarks.trim()) {
                    payload.remarks = this.renew.remarks.trim();
                }

                this.renew_loading = true;

                this.$axios
                    .post("api/admin/tvShow/renew", payload, config)
                    .then((response) => {
                        // API may return status as boolean true or string "true"
                        if (response.data.status === true || response.data.status === "true") {
                            this.$swal("", response.data.message || "TV show renewed successfully", "success");
                            this.hideModal('renew-modal');
                            this.fetchTvShowDetail();
                        } else {
                            this.$swal("", response.data.message || "Failed to renew TV show", "error");
                        }
                    })
                    .catch((error) => {
                        if (error.response) {
                            if (error.response.data && error.response.data.message) {
                                if (typeof error.response.data.message === 'object') {
                                    this.renew_errors = error.response.data.message;
                                } else {
                                    this.$swal("", error.response.data.message, "error");
                                }
                            } else {
                                this.$swal("", "Something went wrong", "error");
                            }
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    })
                    .finally(() => (this.renew_loading = false));
            },

            statusLabel(status) {
                if (status === 1 || status === '1' || status === 'Active') return 'Active';
                if (status === 0 || status === '0' || status === 'Inactive') return 'Inactive';
                if (status === 2 || status === '2' || status === 'Expired') return 'Expired';
                return status != null && status !== '' ? status : '-';
            },

            renewedBy(log) {
                return log.renewed_by_label
                    || log.renewed_by_name
                    || log.admin_name
                    || log.user_name
                    || '-';
            },

            formatLogDate(value) {
                if (!value) return '-';
                return moment(value).format("DD MMM YYYY");
            },

            formatLogDateTime(value) {
                if (!value) return '-';
                return moment(value).format("DD MMM YYYY, hh:mm A");
            },

        }
    }
</script>
    
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                   
                        <!----- top button area starts---->
                        <div class="row mb-2">
                            <div class="col-12">
                                <router-link :to="{ name: 'tvshows' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                                <button v-if="tv_show.can_renew" type="button" class="btn btn-success float-end me-2" @click="openRenewModal">Renew</button>
                            </div>
                        </div>
                        <!----- top button area ends---->                  

                        <!---- Details starts -------->
                        <div class="row">

                            <div class="col-lg-12 col-md-12">
                                <b-card header-class="bg-transparent border-light" class="border border-light">
                                    <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 p-3 mb-3">TV Show Details</h4>

                                    <div class="table-responsive ">
                                        <table class="table table-nowrap mb-0">
                                            <tbody>
                                                <tr width="50%">
                                                    <th scope="row">Title</th>
                                                    <th>:</th>
                                                    <td>{{tv_show.title}}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">For</th>
                                                    <th>:</th>
                                                    <td>
                                                        <span v-if="tv_show.type==1">All Clinics</span>
                                                        <span v-if="tv_show.type==2">Multiple Clinics</span>
                                                        <span v-if="tv_show.type==3">All Doctors</span>
                                                        <span v-if="tv_show.type==4">Multiple Doctors</span>
                                                        <span v-if="tv_show.type==5">Specific Clinic</span>
                                                        <span v-if="tv_show.type==6">Specific Doctor</span>
                                                        <span v-if="tv_show.type==7">All Pharmacies</span>
                                                        <span v-if="tv_show.type==8">Multiple Pharmacies</span>
                                                        <span v-if="tv_show.type==9">Specific Pharmacy</span>
                                                        <span v-if="tv_show.type==10">All Labs</span>
                                                        <span v-if="tv_show.type==11">Multiple Labs</span>
                                                        <span v-if="tv_show.type==12">Specific Lab</span>
                                                    </td>
                                                </tr> 

                                                <tr>
                                                    <th scope="row">Agency</th>
                                                    <th>:</th>
                                                    <td>{{tv_show.agency_name}}</td>
                                                </tr>  

                                                <tr v-if="tv_show.clinic_id">
                                                    <th scope="row">Clinic</th>
                                                    <th>:</th>
                                                    <td>{{tv_show.clinic_name}}</td>
                                                </tr>  

                                                <tr v-if="tv_show.doctor_id">
                                                    <th scope="row">Doctor</th>
                                                    <th>:</th>
                                                    <td>{{tv_show.doctor_name}}</td>
                                                </tr> 

                                                <tr v-if="tv_show.pharmacy_id">
                                                    <th scope="row">Pharmacy</th>
                                                    <th>:</th>
                                                    <td>{{tv_show.pharmacy_name}}</td>
                                                </tr>  

                                                <tr v-if="tv_show.lab_id">
                                                    <th scope="row">Lab</th>
                                                    <th>:</th>
                                                    <td>{{tv_show.lab_name}}</td>
                                                </tr>  

                                                <tr>
                                                    <th scope="row">Duration</th>
                                                    <th>:</th>
                                                    <td>{{tv_show.duration}} sec</td>
                                                </tr>  

                                                <tr>
                                                    <th scope="row">Slot</th>
                                                    <th>:</th>
                                                    <td>{{tv_show.slot}}</td>
                                                </tr>  

                                                <tr>
                                                    <th scope="row">Expired on</th>
                                                    <th>:</th>
                                                    <td>{{tv_show.validity | formatDate}}</td>
                                                </tr>

                                                <tr v-if="tv_show.status !== undefined && tv_show.status !== null && tv_show.status !== ''">
                                                    <th scope="row">Status</th>
                                                    <th>:</th>
                                                    <td>{{ statusLabel(tv_show.status) }}</td>
                                                </tr>    

                                                <tr>
                                                    <th scope="row">Created on</th>
                                                    <th>:</th>
                                                    <td>{{tv_show.created_at | formatDate}}</td>
                                                </tr>    

                                                <tr>
                                                    <th scope="row">Video</th>
                                                    <th>:</th>
                                                    <td>
                                                        <a :href="$image_url + tv_show.video" target="_blank" class="font-size-22"><i class='bx bx-video'></i></a>
                                                    </td>
                                                </tr>  
                                            </tbody>
                                        </table>
                                    </div>

                                    <div v-if="Boolean(tv_names.length)">
                                        <div class="table-responsive">
                                            <table class="table table-bordered mb-0">
                                                <thead class="table-light">
                                                    <tr align="center">
                                                        <th>TV Id</th>
                                                        <th>Name</th>
                                                        <th>Username</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="tv in tv_names" :key="tv.id" align="center">
                                                        <td>{{tv.id}}</td>
                                                        <td>{{tv.name}}</td>
                                                        <td>{{tv.username}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                
                                </b-card>
                            </div>
                        </div>

                        <!---- Renew history ---->
                        <div class="row mt-3">
                            <div class="col-lg-12 col-md-12">
                                <b-card header-class="bg-transparent border-light" class="border border-light">
                                    <h4 class="font-size-18 bg-light border border-top-0 border-start-0 border-end-0 p-3 mb-3">Renew History</h4>
                                    <div class="table-responsive">
                                        <table class="table table-bordered mb-0">
                                            <thead class="table-light">
                                                <tr>
                                                    <th>Old Validity</th>
                                                    <th>New Validity</th>
                                                    <th>Renewed By</th>
                                                    <th>Remarks</th>
                                                    <th>Renewed On</th>
                                                </tr>
                                            </thead>
                                            <tbody v-if="Boolean(renew_logs.length)">
                                                <tr v-for="(log, index) in renew_logs" :key="log.id || index">
                                                    <td>{{ formatLogDate(log.old_validity) }}</td>
                                                    <td>{{ formatLogDate(log.new_validity) }}</td>
                                                    <td>{{ renewedBy(log) }}</td>
                                                    <td>{{ log.remarks || '-' }}</td>
                                                    <td>{{ formatLogDateTime(log.renewed_on || log.created_at) }}</td>
                                                </tr>
                                            </tbody>
                                            <tbody v-else>
                                                <tr>
                                                    <td colspan="5" class="text-center">{{ logs_loading ? 'Loading...' : 'No renew history found' }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </b-card>
                            </div>
                        </div>

                        <b-modal ref="renew-modal" id="renew-modal" title="Renew TV Show" hide-footer @hidden="clearRenewForm()">
                            <b-form @submit.prevent="renewTVShow()">
                                <div class="row">
                                    <b-col md="12" class="form-group">
                                        <label class="control-label">Current Validity</label>
                                        <b-form-input :value="formatLogDate(tv_show.validity)" disabled></b-form-input>
                                    </b-col>
                                    <b-col md="12" class="form-group">
                                        <label class="control-label">New Validity <span class="text-danger">*</span></label>
                                        <b-form-input
                                            type="date"
                                            v-model="renew.validity"
                                            :min="today"
                                            v-bind:class="{ 'is-invalid': Boolean(renew_errors.validity) }"
                                        ></b-form-input>
                                        <div v-for="(val, index) in renew_errors.validity" :key="'validity-' + index" class="invalid-feedback">
                                            <p class="mb-0">{{ val }}</p>
                                        </div>
                                    </b-col>
                                    <b-col md="12" class="form-group">
                                        <label class="control-label">Remarks</label>
                                        <b-form-textarea
                                            v-model="renew.remarks"
                                            rows="3"
                                            v-bind:class="{ 'is-invalid': Boolean(renew_errors.remarks) }"
                                        ></b-form-textarea>
                                        <div v-for="(val, index) in renew_errors.remarks" :key="'remarks-' + index" class="invalid-feedback">
                                            <p class="mb-0">{{ val }}</p>
                                        </div>
                                    </b-col>
                                    <b-col md="12" class="mt-2">
                                        <div v-if="!renew_loading">
                                            <b-button type="submit" class="me-3" variant="primary">Renew</b-button>
                                            <b-button variant="light" @click="hideModal('renew-modal')">Close</b-button>
                                        </div>
                                        <div v-else class="page-loader">
                                            <img src="@/assets/images/preloaderspin.gif"/>
                                        </div>
                                    </b-col>
                                </div>
                            </b-form>
                        </b-modal>

                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
<style lang="scss" scoped>
  .page-loader img {
   max-width: 30px;
  }
</style>
